import { Locale, setDefaultOptions } from 'date-fns';
import { enUS, it } from 'date-fns/locale';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const dateFnsLocales: Record<string, Locale> = { en: enUS, it };

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: localStorage.getItem('i18nextLng') || undefined,
    supportedLngs: ['en', 'it'],
    fallbackLng: 'en',
    ns: ['auth', 'links', 'nav-header', 'org-settings', 'account', 'listing', 'reputation', 'notifications'],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'navigator', 'localStorage', 'sessionStorage', 'cookie', 'htmlTag'],
      convertDetectedLanguage: (lng: string) => lng.split('-')[0],
    },
  });

i18n.on('languageChanged', (lng) => {
  setDefaultOptions({ locale: dateFnsLocales[lng] || enUS });
});

// Imposta il locale iniziale
setDefaultOptions({ locale: dateFnsLocales[i18n.language] || enUS });

export default i18n;
